import React from 'react';
import './BasemapSelectorToggle.scss';

const BasemapSelectorToggle = props => {
  return (
    <div
      className="basemap-selector-toggle esri-icon-basemap"
      onClick={() => props.toggleFunction()}
    />
  );
};

export default BasemapSelectorToggle;
